import { getId } from '@adalo/utils'

const STORAGE_KEY = 'adalo_action_clipboard'

let listeners = []

const getClipboardData = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)

    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export const copyActionChain = action => {
  if (!action) return

  localStorage.setItem(STORAGE_KEY, JSON.stringify(action))
  listeners.forEach(fn => fn())
}

export const getActionClipboard = () => getClipboardData()

export const hasActionClipboard = () => getClipboardData() !== null

export const subscribe = listener => {
  listeners.push(listener)

  return () => {
    listeners = listeners.filter(fn => fn !== listener)
  }
}

/**
 * Returns a deep clone of the clipboard data with fresh IDs
 * for all action items so they can be pasted without conflicts.
 */
export const pasteActionChain = () => {
  const clipboardData = getClipboardData()

  if (!clipboardData) return null

  const cloned = JSON.parse(JSON.stringify(clipboardData))

  if (cloned.actions) {
    cloned.actions = cloned.actions.map(item => ({
      ...item,
      id: getId(),
    }))
  }

  return cloned
}
